'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var React = require('react');
var Avatar = require('../../../DesignSystem/DataDisplay/Avatar/Avatar.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var JenellePersona = function JenellePersona(_ref) {
  var props = _extends["default"]({}, _ref);

  return React__default["default"].createElement(Avatar, _extends["default"]({}, props, {
    alt: "Jenelle",
    src: "https://housecall-general.s3-us-west-1.amazonaws.com/Assets/Onboarding/Jenelle.png"
  }));
};

JenellePersona.defaultProps = {
  borderColor: '#e0e0e0',
  width: 100
};

module.exports = JenellePersona;
